import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPageData, UIError } from 'common/interfaces';
import {
  ICashEntry,
  ICouponSalesEntry,
  IDropsEntry,
  IDropsEntryData,
  ILotteryPOEntry,
  ILotterySalesEntry,
  IMOSalesEntry,
  IMiscPOEntry,
  IMiscPOEntryData,
  ISalesAttachment,
  ISalesAttachmentType,
  IUpdateSalesEntryState,
  IVoidEntry,
} from 'common/interfaces/isales';
import { SalesEntryType } from 'common/interfaces/ishiftReport';

const initialState: IUpdateSalesEntryState = {
  loading: false,
  error: null,
  isUpdated: undefined,
  cashEntry: undefined,
  lotterySales: undefined,
  moSales: undefined,
  moSalesList: undefined,
  lotteryPO: undefined,
  miscPO: undefined,
  miscPOList: undefined,
  couponSales: undefined,
  lotterySalesList: undefined,
  couponSalesList: undefined,
  attachments: undefined,
  voidEntry: undefined,
  dropsEntry: undefined,
  dropsList: undefined,
};

const reducers = {
  setLoading: (state: IUpdateSalesEntryState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IUpdateSalesEntryState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IUpdateSalesEntryState) => {
    // _.merge(state, initialState);

    state.isUpdated = undefined;
    state.lotterySales = undefined;
    state.moSales = undefined;
    state.couponSales = undefined;
    state.error = undefined;
  },

  setCashEntry: (state: IUpdateSalesEntryState, action: PayloadAction<ICashEntry | null>) => {
    state.cashEntry = action.payload;
  },
  setVoidEntry: (state: IUpdateSalesEntryState, action: PayloadAction<IVoidEntry | null>) => {
    state.voidEntry = action.payload;
  },
  setLotterySalesEntry: (state: IUpdateSalesEntryState, action: PayloadAction<ILotterySalesEntry | null>) => {
    state.lotterySales = action.payload;
  },
  setLotterySalesList: (state: IUpdateSalesEntryState, action: PayloadAction<IPageData<ILotterySalesEntry> | null>) => {
    state.lotterySalesList = action.payload;
  },
  setMOSalesEntry: (state: IUpdateSalesEntryState, action: PayloadAction<IMOSalesEntry | null>) => {
    state.moSales = action.payload;
  },
  setMOSalesList: (state: IUpdateSalesEntryState, action: PayloadAction<IPageData<IMOSalesEntry> | null>) => {
    state.moSalesList = action.payload;
  },
  setMiscPOList: (state: IUpdateSalesEntryState, action: PayloadAction<IPageData<IMiscPOEntry> | null>) => {
    state.miscPOList = action.payload;
  },
  setUpdated: (state: IUpdateSalesEntryState, action: PayloadAction<SalesEntryType | undefined>) => {
    state.isUpdated = action.payload;
  },
  setLotteryPO: (state: IUpdateSalesEntryState, action: PayloadAction<ILotteryPOEntry | null>) => {
    state.lotteryPO = action.payload;
  },
  setMiscPO: (state: IUpdateSalesEntryState, action: PayloadAction<IMiscPOEntryData | null>) => {
    state.miscPO = action.payload;
  },
  setCouponSales: (state: IUpdateSalesEntryState, action: PayloadAction<ICouponSalesEntry | null>) => {
    state.couponSales = action.payload;
  },
  setCouponSalesList: (state: IUpdateSalesEntryState, action: PayloadAction<IPageData<ICouponSalesEntry> | null>) => {
    state.couponSalesList = action.payload;
  },
  setAttachments: (
    state: IUpdateSalesEntryState,
    action: PayloadAction<{
      type: SalesEntryType;
      attachments?: ISalesAttachment[];
    } | null>,
  ) => {
    if (!state.attachments) {
      state.attachments = {} as ISalesAttachmentType;
    }
    console.log('setAttachments::', action.payload);

    if (action.payload?.type) {
      state.attachments[action.payload.type] = action.payload?.attachments;
    }
  },
  addAttachment: (
    state: IUpdateSalesEntryState,
    action: PayloadAction<{
      type: SalesEntryType;
      attachment: ISalesAttachment;
    } | null>,
  ) => {
    if (!state.attachments) {
      state.attachments = {} as ISalesAttachmentType;
    }
    console.log('setAttachments::', action.payload);
    if (action.payload && action.payload.type && action.payload.attachment) {
      let existingAttachments = state.attachments[action.payload.type];
      if (!existingAttachments) {
        existingAttachments = [];
        state.attachments[action.payload.type] = existingAttachments;
      }
      existingAttachments.push(action.payload.attachment);
    }
  },
  setDropsEntry: (state: IUpdateSalesEntryState, action: PayloadAction<IDropsEntryData | null>) => {
    state.dropsEntry = action.payload;
  },
  setDropsList: (state: IUpdateSalesEntryState, action: PayloadAction<IPageData<IDropsEntry> | null>) => {
    state.dropsList = action.payload;
  },
};

const updateSalesEntrySlice = createSlice({
  name: 'IUpdateSalesEntryState',
  initialState: initialState,
  reducers: reducers,
});

export default updateSalesEntrySlice.reducer;
export const UpdateSalesEntryActions = updateSalesEntrySlice.actions;
